import { render, staticRenderFns } from "./SubmitTicket.vue?vue&type=template&id=e58beba8&"
import script from "./SubmitTicket.vue?vue&type=script&lang=js&"
export * from "./SubmitTicket.vue?vue&type=script&lang=js&"
import style0 from "./SubmitTicket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports